import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import { EVENTS_CONSTANTS } from "config/constants";
import { requestDeleteEventById } from "services/events/aboutEvents";
import { eventsSessionStorage } from "services/storage/events";
import useMainContext from "utils/context/useMainContext";

const useDeleteEvent = ({ loadingRequest, eventResumeData, goToEventList }) => {
	const mainContext = useMainContext();
	const dialog = useShowDialogAlert();
	function errorResponse(message) {
		if (message) {
			const errorText =
				EVENTS_CONSTANTS
					.FORM_ERROR_TEXT_LIST_PER_FORM_ACTION_ERROR_CODE[message];
			if (errorText)
				mainContext.setDialogUnexpectedErrorMessage(errorText);
		}
		mainContext.setShowDialogUnexpectedError(true);
	}
	function successResponse() {
		eventsSessionStorage.eventId.remove();
		eventsSessionStorage.eventTitleForEventToastMessage.set(
			eventResumeData.step1.title
		);
		goToEventList();
	}
	const deleteEvent = async () => {
		dialog.set(false);
		loadingRequest.show("Eliminando...");
		const { message, success } = await requestDeleteEventById(
			eventsSessionStorage.eventId.get()
		);
		loadingRequest.hide();
		if (success) successResponse();
		else errorResponse(message);
	};
	return {
		action: deleteEvent,
		dialog,
	};
};

export default useDeleteEvent;
